/**
 * Present when the radio is checked.
 */
export const checked = 'data-checked';
/**
 * Present when the radio is not checked.
 */
export const unchecked = 'data-unchecked';
/**
 * Present when the radio is disabled.
 */
export const disabled = 'data-disabled';
/**
 * Present when the radio is readonly.
 */
export const readonly = 'data-readonly';
/**
 * Present when the radio is required.
 */
export const required = 'data-required';
/**
 * Present when the radio is in a valid state (when wrapped in Field.Root).
 */
export const valid = 'data-valid';
/**
 * Present when the radio is in an invalid state (when wrapped in Field.Root).
 */
export const invalid = 'data-invalid';
/**
 * Present when the radio has been touched (when wrapped in Field.Root).
 */
export const touched = 'data-touched';
/**
 * Present when the radio's value has changed (when wrapped in Field.Root).
 */
export const dirty = 'data-dirty';
/**
 * Present when the radio is checked (when wrapped in Field.Root).
 */
export const filled = 'data-filled';
/**
 * Present when the radio is focused (when wrapped in Field.Root).
 */
export const focused = 'data-focused';
